import React, { lazy, Suspense } from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Loading from 'components/Utils/Loading'

const DesignerRework = lazy(() => import('packages/@slerp/designer-rework'))

export const DesignerReworkWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Suspense fallback={<Loading />}>
            <DesignerRework />
          </Suspense>
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
